(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ed-footer-signup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.edfsReady === 'true') return;
      root.dataset.edfsReady = 'true';
      const options = Array.from(root.querySelectorAll('[data-edfs-option]'));
      const allOption = root.querySelector('[data-edfs-all]');
      const tags = root.querySelector('[data-edfs-tags]');
      const submit = root.querySelector('[data-edfs-submit]');
      const status = root.querySelector('[data-edfs-status]');
      const submitError = root.querySelector('[data-edfs-error]');
      const kidsToggle = root.querySelector('[data-edfs-kids-toggle]');
      const agesWrap = root.querySelector('[data-edfs-ages]');
      const ages = Array.from(root.querySelectorAll('[data-edfs-age]'));

      const sync = (changed) => {
        if (changed) {
          if (changed === allOption && allOption.checked) {
            options.forEach((option) => { if (option !== allOption) option.checked = false; });
          } else if (changed !== allOption && changed.checked && allOption) {
            allOption.checked = false;
          }
        }
        const selected = options.filter((option) => option.checked);
        const selectedAges = ages.filter((age) => age.checked);
        const kidsNeedsAge = kidsToggle && kidsToggle.checked && selectedAges.length === 0;
        const kidTags = kidsToggle && kidsToggle.checked ? ['kids-world', ...selectedAges.map((age) => age.value)] : [];
        if (tags) tags.value = ['newsletter', ...selected.map((option) => option.value), ...kidTags].join(',');
        if (submit) submit.disabled = selected.length === 0 || kidsNeedsAge;
        if (status) status.textContent = kidsNeedsAge ? 'Choose at least one Kids World age group.' : selected.length ? `${selected.length} selected — add your email to unlock 10%.` : 'Choose at least one option to continue.';
      };

      options.forEach((option) => option.addEventListener('change', () => sync(option)));
      if (kidsToggle) kidsToggle.addEventListener('change', () => {
        if (agesWrap) agesWrap.hidden = !kidsToggle.checked;
        if (!kidsToggle.checked) ages.forEach((age) => { age.checked = false; });
        sync();
      });
      ages.forEach((age) => age.addEventListener('change', () => sync()));
      sync();
      const dialog=root.querySelector('[data-edfs-dialog]');
      const form=root.querySelector('.edfs__form');
      const home=root.querySelector('[data-edfs-home]');
      if(form){
        form.addEventListener('submit',()=>{
          sync();
          if(submitError){submitError.hidden=true;submitError.textContent='';}
          if(submit){
            submit.disabled=true;
            submit.dataset.label=submit.textContent;
            submit.textContent='Joining…';
          }
          window.setTimeout(()=>{
            if(document.visibilityState==='visible'&&submit&&submit.disabled){
              submit.disabled=false;
              submit.textContent=submit.dataset.label||'Try again';
              if(submitError){
                submitError.hidden=false;
                submitError.textContent='Shopify did not finish the signup. Check the email address and try once more.';
              }
            }
          },12000);
        });
      }
      let opener=null, oldOverflow='';
      if(dialog&&form&&home){
        const onTrigger=(event)=>{
          const trigger=event.target.closest('[data-ed-discount-trigger]');
          if(!trigger||!root.isConnected||typeof dialog.showModal!=='function')return;
          event.preventDefault();
          if(dialog.open)return;
          opener=trigger;oldOverflow=document.body.style.overflow;
          dialog.querySelector('[data-edfs-dialog-body]').append(form);
          dialog.showModal();document.body.style.overflow='hidden';
          dialog.querySelector('[data-edfs-close]').focus({preventScroll:true});
        };
        const restore=()=>{
          home.append(form);document.body.style.overflow=oldOverflow;
          if(opener&&opener.isConnected)opener.focus({preventScroll:true});
        };
        dialog.addEventListener('close',restore);
        dialog.querySelector('[data-edfs-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',(event)=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
        document.addEventListener('click',onTrigger);
        const onUnload=(event)=>{
          if(!event.target.contains(root))return;
          if(dialog.open)dialog.close();
          document.removeEventListener('click',onTrigger);
          document.removeEventListener('shopify:section:unload',onUnload);
        };
        document.addEventListener('shopify:section:unload',onUnload);
      }

      const copy = root.querySelector('[data-edfs-copy]');
      if (copy) {
        copy.addEventListener('click', async () => {
          const box = copy.closest('[data-code]');
          const code = box ? box.dataset.code : '';
          if (!code) return;
          try {
            await navigator.clipboard.writeText(code);
            const original = copy.textContent;
            copy.textContent = 'Copied';
            window.setTimeout(() => { copy.textContent = original; }, 1600);
          } catch (error) {
            copy.textContent = code;
          }
        });
      }
    };

    document.querySelectorAll('[data-edfs]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-edfs]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
